/**
 * Клиентская карточка сотрудника (роут /staff/:id): личные данные + блоки «Условия труда» и
 * «Обучения». Грузится в своём скоупе клиента (companyApi).
 * Возврат «Назад» (D1, p3-structure-sout-training §2): `useBackTarget('/staff')` — на страницу,
 * с которой был выполнен переход (`location.state.from`), а без неё (прямой заход по URL/
 * перезагрузка/новая вкладка) — фолбэк «Сотрудники», как было раньше.
 */
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { companyApi } from '@/lib/api'
import { backState, useBackTarget } from '@/lib/use-back-target'
import { PageHead } from '@/design-system/components/layout/page-head'
import { EmployeeCardLoader } from '@/company/employee-card-loader'
import { useTrainingOrderStart } from '@/training/training-order-start'
import { Alert } from '@/design-system/components/feedback/alert'

export function EmployeePage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = useParams<{ id: string }>()
  const goBack = useBackTarget('/staff')
  // «Обучить сотрудника» (training-order-entry-points; ТЗ п.5.1, В22): заявка по его просроченным и
  // истекающим программам или с ним в каждой выбранной программе.
  const trainingStart = useTrainingOrderStart()

  return (
    <div>
      <PageHead title="Карточка сотрудника" />
      {trainingStart.error ? (
        <Alert variant="danger" className="mb-4">
          {trainingStart.error}
        </Alert>
      ) : null}
      {trainingStart.dialog}
      {id ? (
        <EmployeeCardLoader
          api={companyApi}
          id={id}
          onBack={goBack}
          onOpenWorkplace={(workplaceId) =>
            navigate(`/workplaces/${workplaceId}`, { state: backState(location) })
          }
          manageDocuments
          onTrainEmployee={(employee) => trainingStart.start(employee)}
          trainEmployeeBusy={trainingStart.starting}
        />
      ) : null}
    </div>
  )
}
